<template>
    <div class="city-area-select">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="60">
            <FormItem class="form-item-area"  prop="province" label="省份">
                <Select  v-model="formValidate.province" placeholder="请选择省份" @on-change="changeProvince">
                    <Option v-for="(item,index) in provinceArr" :key="item.id" :value="item.id" >{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem class="form-item-area" prop="city" label="城市">
                <Select  v-model="formValidate.city" placeholder="请选择城市" @on-change="changeCity">
                    <Option v-for="(item,index) in citiesArr" :key="item.id" :value="item.id" >{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem class="form-item-area" prop="county" label="区县">
                <Select  v-model="formValidate.county" placeholder="请选择区县" @on-change="changeCounty">
                    <Option v-for="(item,index) in countyArr" :key="item.id" :value="item.id" >{{ item.name }}</Option>
                </Select>
            </FormItem>
        </Form>
    </div>
</template>

<script>
    import api from '../api/api'
    var self = this;
    export default {
        data(){
            return{
                isMultiple: false,
                provinceArr: [],
                citiesArr: [],
                countyArr:[],
                formValidate: {
                    province: '',
                    city: '',
                    county: '',
                },
                ruleValidate: {
                    province: [
                        { required: true, message: '请选择收货地所属的省份', trigger: 'change' }
                    ],
                    city: [
                        { required: true, message: '请选择收货地所属的市', trigger: 'blur' }
                    ],
                    county: [
                        { required: true, message: '请选择收货地所属的区县', trigger: 'blur' }
                    ]
                },
                currentLever:1,
                selectId:'',
                selectName:''
            }
        },
        mounted(){
            self = this;
            this.getAreaList()
        },
        methods: {
            handleClear(){
                this.formValidate= {
                        province: '',
                        city: '',
                        county: '',
                }
            },
            parseAreaList(list,key){
                list.forEach(function (item) {
                    self[key].push(item);
                })
            },
            getAreaList(){
                let level = this.currentLever
                let data = {
                    // level: level,
                    // name: this.selectName,
                    pId: this.selectId
                }
                api.getAreaData(data).then(res=>{
                    if(level==1){
                       self.parseAreaList(res,'provinceArr')
                    }else if(level==2){
                        self.parseAreaList(res,'citiesArr')
                    }else{
                        self.parseAreaList(res,'countyArr')

                    }
                })
            },
            parseChangeData(arrType,id){
                for(var i=0; i<this[arrType].length; i++){
                    if(id == this[arrType][i].id ){
                        this.selectId = this[arrType][i].id;
                        this.selectName = this[arrType][i].name;
                        break
                    }
                }
                if(arrType=='provinceArr'){
                    this.currentLever = 2;
                    this.citiesArr = [];
                    this.countyArr = [];
                }else if(arrType=='citiesArr'){
                    this.currentLever = 3;
                    this.countyArr = [];
                }
            },
            changeProvince(id){
                this.parseChangeData('provinceArr',id)
                this.emitAreaDate('province',id)
                this.getAreaList()
            },
            changeCity(id){
                this.parseChangeData('citiesArr',id)
                this.emitAreaDate('city',id)
                this.getAreaList()
            },
            changeCounty(id){
                this.emitAreaDate('county',id)

            },
            emitAreaDate(type,id){
                this.$emit('areaChange',{
                    type:type,
                    id:id
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .city-area-select{
        width: 100%;
        height: 40px;
        .form-item-area{
            float: left;
            width: 33%;
        }

    }
    .ivu-form .ivu-form-item-label{
        font-size: 16px;
    }
    .form-item{
        width: 33%;
        float: left;
    }
</style>